export default __webpack_public_path__ + "static/media/Wall_Door_Right_Orange.256.105d8acf.png";